/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = ["body[_ngcontent-%COMP%], html[_ngcontent-%COMP%]{font-family:Montserrat,sans-serif!important}  .p_progressbar .p-progressbar-label{background:#ef5439;color:#fff}.white-bg-upload-btn[_ngcontent-%COMP%]{background-color:#fff;color:#004aad;border-radius:5px}@media (max-width:510px){.table-text[_ngcontent-%COMP%]{font-size:10px}}"];
export { styles as styles };

